let setLocalStorageJSON = (key, data) => {
    localStorage.setItem(key, JSON.stringify(data));
  };
  let getLocalStorageJSON = (key) => {
      let dd = localStorage.getItem(key);

          // Attempt to parse JSON in case it's a valid JSON string
          return JSON.parse(dd);
      
    };
    
  let removeLocalStorageJSON = (key) => {
    localStorage.removeItem(key);
  };

export {
    setLocalStorageJSON,
    getLocalStorageJSON,
    removeLocalStorageJSON,
};